import { Stack, Typography } from '@mui/material';
import { useDashStore } from 'src/hooks';
import { Card } from 'src/components';
import AppUser, { DEMOGRAPHIC_LABEL_MAPS, Demographics, DEMOGRAPHICS_LABELS } from 'src/types/AppUser';
import React from 'react';

const DemographicsComponent = ({ data }: { data: string }) => {
  try {
    let obj: string | Demographics = data;
    while (typeof obj === 'string') {
      obj = JSON.parse(obj);
    }
    obj = obj as Demographics;
    
    return (
      <Stack
        direction="row"
        gap={2}
        sx={{ height: '100%', overflow: 'auto', padding: 2 }}
        flexWrap={'wrap'}>
        {Object.entries(obj).map(([key, value]) => {
          return (
            <Card
              key={key}
              title={DEMOGRAPHICS_LABELS[key] || key}
              sx={{ width: 'fit-content', maxWidth: '300px' }}>
              {Array.isArray(value) ? (
                <ArrayComponent data={value} labelMap={DEMOGRAPHIC_LABEL_MAPS[key]} />
              ) : 
              typeof value === 'object' ? (
                <ObjectComponent data={value} />
              ) : (
                <Typography variant="body2">{String(value)}</Typography>
              )}
            </Card>
          );
        })}
      </Stack>
    );
  } catch (error) {
    console.error('Error parsing demographics', 'with value:', data, 'Error:', error);
    return <Typography variant="body2">{String(data)}</Typography>;
  }
};

const ArrayComponent = ({ data, labelMap }: { data: any[]; labelMap?: Record<any, string> }) => {
  return (
    <Stack direction="column" gap={1}>
      {data.map((item, index) => (
        <Typography key={index} variant="body2">
          {labelMap ? labelMap[item] || item : item}
        </Typography>
      ))}
    </Stack>
  );
};

const ObjectComponent = ({ data }: { data: string }) => {
  try {
    let obj = data;
    while (typeof obj === 'string') {
      obj = JSON.parse(obj);
    }
    return (
      <Stack
        direction="row"
        gap={2}
        sx={{ height: '100%', overflow: 'auto', padding: 2 }}
        flexWrap={'wrap'}>
        {Object.entries(obj).map(([key, value]) => (
          <Card key={key} title={key} sx={{ width: 'fit-content', maxWidth: '300px' }}>
            {typeof value === 'string' && (value.includes('{') || value.includes('[')) ? (
              <ObjectComponent data={value} />
            ) : (
              <Typography variant="body2">{String(value)}</Typography>
            )}
          </Card>
        ))}
      </Stack>
    );
  } catch (error) {
    return <Typography variant="body2">{String(data)}</Typography>;
  }
};

const Profile = () => {
  const { selectedUser, appUsers }: { selectedUser: any; appUsers: AppUser[] } = useDashStore();
  const currentUserData = appUsers.find((user: AppUser) => user.id === selectedUser.id);
  console.log('Current User Data:', currentUserData);
  const ignoredKeys = new Set(['id', 'createdAt', 'updatedAt', 'userGroups', 'usernames']);

  return (
    <>
      <Stack direction="row" gap={2} sx={{ overflow: 'auto', padding: 2 }} flexWrap={'wrap'}>
        {currentUserData &&
          Object.entries(currentUserData).map(
            ([key, value]) =>
              !ignoredKeys.has(key) && (
                <Card key={key} title={key} sx={{ width: 'fit-content' }}>
                  {key === 'demographics' ? (
                    <DemographicsComponent data={value} />
                  ) : typeof value === 'string' && value.includes('{') ? (
                    <ObjectComponent data={value} />
                  ) : typeof value === 'string' && value.includes('[') ? (
                    <ArrayComponent data={JSON.parse(value)} />
                  ) : (
                    <Typography variant="body1">{String(value)}</Typography>
                  )}
                </Card>
              )
          )}
      </Stack>
    </>
  );
};

export default Profile;
